/**
 * お知らせ
 */
import Repository from "./Repository";

const resource = "";
export default {
  /**
   * お知らせ一覧取得
   * @param infoKndCd お知らせ種別
   * @param areaCd エリアコード
   * @param target お知らせ対象
   * @param summaryCd お知らせ分類
   */
  getRsltListInfo(infoKndCd, areaCd, target, summaryCd) {
    let param1 = infoKndCd == null ? "all" : infoKndCd;
    let param2 = areaCd == null ? "all" : areaCd;
    let param3 = target == null ? "all" : target;
    let param4 = Array.from(summaryCd);
    if (param4.length === 0) {
      param4[0] = "none";
    }
    return Repository.get(
      `${resource}/info/list` +
        `/` +
        param1 +
        `/` +
        param2 +
        `/` +
        param3 +
        `/` +
        param4
    );
  },
  /**
   * お知らせ詳細情報取得
   * @param infoManageCd お知らせ管理番号
   */
  getInformationInfo(infoManageCd) {
    return Repository.get(`${resource}/info/detail/` + infoManageCd);
  },
};
